pez.module('banner-image', function($, $el) {
    var src = $el.data().src;
    var img = new Image();
    var visible = false;

    function makeVisible() {
        if(visible) return;
        visible = true;
        $el.find('.banner-image').animate({ opacity: 1 });
        setTimeout(function() {
            var $cascades = $el.find('.anim-cascade').css({ opacity: 0 });
            $el.find('.banner-content').animate({ opacity: 1 });
            $cascades.each(function(i) {
                var $cascade = $(this);
                setTimeout(function() {
                    $cascade.animate({ opacity: 1 });
                }, 300 * (i + 1));
            });
        }, 1500);
    }

    img.onload = function() {
        makeVisible();
    };

    if(!src) {
        makeVisible();
    } else {
        setTimeout(makeVisible, 5000);
        img.src = src;
    }
});
